import React, { Fragment } from "react";
import { RouteComponentProps } from "react-router-dom";
import { User } from "../helpers/shared-interfaces";
import dashboards from "../config/dashboards";
import { Empty } from "antd";

export interface dashboard {
  department: string;
  component: typeof React.Component;
}

export interface dashboardSelectorProps {
  dashboards: dashboard[];
  user: User;
  props: RouteComponentProps;
}

export function DashboardSelector({
  dashboards,
  user,
  props,
}: dashboardSelectorProps): JSX.Element {
  let selectedDashboard: JSX.Element = (
    <Fragment>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
        <Empty
          description={
            <span style={{ color: "#8c8c8c", fontSize: 16 }}>
              No dashboard available for your department
            </span>
          }
        />
      </div>
    </Fragment>
  );
  let Component: typeof React.Component;
  for (const dashboard of dashboards) {
    if (dashboard.department === user.department.name) {
      Component = dashboard.component;
      selectedDashboard = (
        <Fragment>
          <Component user={user} {...props} />
        </Fragment>
      );
    }
  }
  return selectedDashboard;
}

interface State {
  isLoading: boolean;
}
interface Props extends RouteComponentProps {
  user: User;
}

export default class Dashboard extends React.Component<Props, State> {
  _isMounted = false;
  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  async componentDidMount(): Promise<void> {
    this._isMounted = true;
    this.setState({ isLoading: false });
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  render(): JSX.Element | null {
    const UI = DashboardSelector({
      dashboards,
      user: this.props.user,
      props: this.props,
    });
    return <Fragment>{UI}</Fragment>;
  }
}
